// extracted by css-extract-rspack-plugin
export default {"benefitList":"CFVqSf50LKgz0N4n","benefitListItem":"gVDwNWOZrLc1JyR1","checkMark":"Exf63Kjjiuk3LnNG","total":"rQsBtr76pUghT8qd"};